import { createFeatureSelector } from '@ngrx/store';

export const terminalsState = createFeatureSelector('terminals');

